var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2028 10.0001L19.6805 2.52209C19.8862 2.31624 19.9997 2.04161 20 1.74876C20 1.45575 19.8865 1.18079 19.6805 0.975265L19.0252 0.320143C18.8192 0.113802 18.5446 0.000793457 18.2514 0.000793457C17.9587 0.000793457 17.6841 0.113802 17.478 0.320143L10.0003 7.7977L2.52228 0.320143C2.31659 0.113802 2.04179 0.000793457 1.74878 0.000793457C1.4561 0.000793457 1.1813 0.113802 0.97561 0.320143L0.32 0.975265C-0.106667 1.40193 -0.106667 2.09592 0.32 2.52209L7.79789 10.0001L0.32 17.4779C0.114146 17.684 0.000813008 17.9587 0.000813008 18.2515C0.000813008 18.5444 0.114146 18.819 0.32 19.025L0.975447 19.6801C1.18114 19.8863 1.4561 19.9995 1.74862 19.9995C2.04163 19.9995 2.31642 19.8863 2.52211 19.6801L10.0002 12.2024L17.4779 19.6801C17.6839 19.8863 17.9585 19.9995 18.2512 19.9995H18.2515C18.5444 19.9995 18.819 19.8863 19.025 19.6801L19.6803 19.025C19.886 18.8192 19.9995 18.5444 19.9995 18.2515C19.9995 17.9587 19.886 17.684 19.6803 17.478L12.2028 10.0001Z",
    fill: "#F9F9F9"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.2ff9f767.svg";
export { ForwardRef as ReactComponent };